module.exports = __webpack_public_path__ + "img/school-menu.c441b2a0.png";